export default function Differentiation() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="text-4xl md:text-5xl font-bold text-[#0F172A] text-center mb-16">
          Why Atlas AI Services
        </h2>

        <div className="grid md:grid-cols-3 gap-12 mb-16">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center border-2 border-[#0F172A]">
              <i className="ri-building-line text-3xl text-[#0F172A]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#0F172A] mb-4">
              Structural Strength
            </h3>
            <p className="text-base text-gray-600 leading-relaxed">
              We build systems that hold weight and scale with you.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center border-2 border-[#0F172A]">
              <i className="ri-focus-3-line text-3xl text-[#0F172A]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#0F172A] mb-4">
              Precision Engineering
            </h3>
            <p className="text-base text-gray-600 leading-relaxed">
              Every automation connects directly to measurable KPIs.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center border-2 border-[#0F172A]">
              <i className="ri-shield-check-line text-3xl text-[#0F172A]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#0F172A] mb-4">
              Enterprise Discipline
            </h3>
            <p className="text-base text-gray-600 leading-relaxed">
              No hype. No experimental chaos. Just controlled execution.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="relative w-full h-[300px]">
            <img
              src="https://public.readdy.ai/ai/img_res/9e51e55c179dbedd54a502ed9c7dcba6.jpg"
              alt="Structural Strength"
              className="w-full h-full object-cover object-center"
            />
          </div>
          
          <div className="relative w-full h-[300px]">
            <img
              src="https://readdy.ai/api/search-image?query=precision%20measurement%20tools%20and%20data%20analytics%20visualization%20with%20exact%20metrics%20and%20KPI%20dashboards%20clean%20geometric%20patterns%20showing%20accuracy%20and%20detailed%20engineering%20minimal%20professional%20aesthetic%20navy%20blue%20and%20white%20technical%20precision%20instruments%20and%20performance%20tracking%20systems&width=600&height=600&seq=diff-precision-001&orientation=squarish"
              alt="Precision Engineering"
              className="w-full h-full object-cover object-center"
            />
          </div>
          
          <div className="relative w-full h-[300px]">
            <img
              src="https://readdy.ai/api/search-image?query=enterprise%20security%20shield%20and%20controlled%20execution%20systems%20with%20organized%20workflow%20processes%20professional%20business%20discipline%20representation%20clean%20structured%20minimal%20design%20navy%20blue%20and%20white%20color%20scheme%20systematic%20approach%20and%20quality%20assurance%20visualization&width=600&height=600&seq=diff-discipline-001&orientation=squarish"
              alt="Enterprise Discipline"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
}